//   api.js
import { post } from "@/request/http";

export const server = {
  postAPI: function(url,paramObj) {
    return post(`/${url}`, paramObj);
  }
};
